import React, { useState } from 'react';
import { Typography } from "antd";
import { ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';

export default function BalanceteBanner() {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

}
